import {
  generateGetResourceKey,
  generateHttpGet,
} from "../../utils/fetcherUtils";

import {
  GetArtworkInlinableFiles$Params,
  GetArtworkInlinableFiles$Result,
} from "./typing";

export const httpGet$GetArtworkInlinableFiles = generateHttpGet<
  GetArtworkInlinableFiles$Params,
  GetArtworkInlinableFiles$Result
>(GetArtworkInlinableFiles$Result.parse);

export const getResourceKey$GetArtworkInlinableFiles =
  generateGetResourceKey<GetArtworkInlinableFiles$Params>([
    "0d3e92ad-2d7e-4924-80c9-4001da2c1dfc",
  ]);
